<div class="appointments">
  <div class="appointments-container">
    <div id="calendar" class="incoming-refferals">
      <div class="patient-search-calendar">
        <span class="patient-seach-apts">
                    <nz-select [visible]="
        calendarVisible() &&
        calendarElement &&
        isResourceTimelineView()
      " style="margin-bottom: 10px; width: 300px"
            [nzPlaceHolder]="(resourceMode === 'members' ? 'Search Users' : 'Search Patients') | translate" nzShowSearch
            nzAllowClear (ngModelChange)="handleResourceSelect($event)" [(ngModel)]="selectedResourceId">
            @for (resource of searchableResources; track resource.id) {
              <nz-option [nzValue]="resource.id"
              [nzLabel]="resource.title"></nz-option>
            }
          </nz-select></span>
          @if (calendarVisible() && isPatientResourceTimelineView()) {
            <div class="patient-resource-filter" role="group" [attr.aria-label]="'Patient resource filter' | translate">
              <button type="button" [class.active]="patientResourceFilter === 'all'"
                (click)="handlePatientResourceFilter('all')">{{ 'All' | translate }}</button>
              <button type="button" [class.active]="patientResourceFilter === 'in'"
                (click)="handlePatientResourceFilter('in')">{{ 'In' | translate }}</button>
              <button type="button" [class.active]="patientResourceFilter === 'out'"
                (click)="handlePatientResourceFilter('out')">{{ 'Out' | translate }}</button>
            </div>
          }
        </div>

        @if (!calendarVisible()) {
          <div fxLayout="column" fxLayoutAlign="center center" class="calendar-spinner">
            <h2>{{ "Processing" | translate }}...</h2>
            <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
          </div>
        }

        @if (calendarVisible()) {
          <full-calendar #calendar [options]="calendarOptions()">
          </full-calendar>
        }
      </div>
    </div>
  </div>

  <!-- These are dynamically loaded components -->
  <div *ngComponentOutlet="addCalentarEventComp"></div>
  <div *ngComponentOutlet="viewCalentarEventComp"></div>
